export default __webpack_public_path__ + "static/media/icon-photo.ac4fe1db.svg";